export class NavigationService {
  isOpen;
  isDisplaySidebar = false;
  policyData;

  removeSidebar() {
    this.isDisplaySidebar = false;
  }

  displaySidebar() {
    this.isDisplaySidebar = true;
  }
}
